import axios from 'axios'
import constants from "../constants";
import util from "../util";
import Renderer from "../canvas/renderer";
import designService from "./designService";
import store from "../store";

const REVISION_PATH = constants.urlPrefix + '/api/revisions';

export function getRevisionContent(revision) {
  return axios.get(`${REVISION_PATH}/${revision.id}/content`);
}
